import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/theme.css";
import "./styles/app.css";
import { App } from "./App.js";
import { EbookReader } from "./reader/EbookReader.js";
import { AuthGate } from "./auth/AuthGate.js";
import { ToastProvider } from "./components/Toast.js";

// The book reader is a standalone route ("Open E-Book", opened in its own tab).
const readMatch = /^\/read\/([^/?#]+)/.exec(window.location.pathname);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ToastProvider>
      <AuthGate>
        {readMatch ? <EbookReader projectId={decodeURIComponent(readMatch[1]!)} /> : <App />}
      </AuthGate>
    </ToastProvider>
  </StrictMode>
);
